<template>
  <v-app class="resetpin">
    <v-main align="center" justify="center">
      <br />
      <!-- CHANGE PIN FORM -->
      <v-container v-if="ok">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="8" lg="5">
            <v-card shaped light class="elevation-12">
              <v-card-title
                class="secondary white--text mb-5 justify-center elevation-12"
                >Reset PIN</v-card-title
              >
              <v-card-text>
                <v-form
                  @submit.prevent="resetPin(pin, pinConfirmed)"
                  id="login-form"
                >
                  <v-row class="justify-center">
                    <v-chip class="ma-2 mr-8 ultramarin white--text"
                      >New PIN</v-chip
                    >
                    <PincodeInput class="PincodeInput" v-model="pin" secure />
                  </v-row>
                  <v-row class="justify-center">
                    <v-chip class="ma-2 ultramarin white--text"
                      >Confirm PIN</v-chip
                    >
                    <PincodeInput
                      class="PincodeInput"
                      v-model="pinConfirmed"
                      secure
                      :autofocus="false"
                    />
                  </v-row>
                </v-form>
              </v-card-text>

              <v-card-actions class="mx-5">
                <v-spacer />
                <v-btn
                  rounded
                  x-large
                  class="primary mb-2 elevation-12"
                  type="submit"
                  form="login-form"
                  >Submit</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <!-- RESET SUCCESSFUL -->
      <div v-if="resetDone">
        <v-img
          class="centerImg"
          src="@/assets/successIcon.png"
          width="200"
          height="200"
        ></v-img>
        <br />
        <v-card
          class="mx-auto"
          max-width="344"
          color="rgba(255, 255, 255, 0.1)"
          outlined
        >
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title
                class="headline mb-1 text-h3 font-weight-medium"
                >PIN changed</v-list-item-title
              >
              <v-list-item-subtitle class="text-h6">
                You have successfully changed your PIN.
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </div>
      <!-- DIALOGS -->
      <Dialog
        :isVisible="dialog"
        @closeDialog="dialog = false"
        :title="dialogTitle"
        :textColor="textColor"
      />
    </v-main>
  </v-app>
</template>

<script>
import PincodeInput from "vue-pincode-input";
import Dialog from "./components/Dialog.vue";

export default {
  name: "ResetPin",
  data() {
    return {
      token: this.$route.params.token,
      resetDone: false,
      ok: false,
      pin: "",
      pinConfirmed: "",
      dialog: false,
      dialogTitle: "",
      textColor: ""
    };
  },
  async created() {
    await this.$http
      .get("reset-pin/" + this.token)
      .then(() => (this.ok = true))
      .catch(() => {
        this.$router.push("/not-found");
      });
  },
  components: {
    PincodeInput,
    Dialog
  },
  computed: {},
  methods: {
    async resetPin(pin, pinConfirmed) {
      if (pin != pinConfirmed) {
        this.$store.dispatch("snackbar/show", {
          content: "PINs must match",
          color: "error"
        });
      } else if (String(pin).length < 4) {
        this.$store.dispatch("snackbar/show", {
          content: "PIN must contain 4 digits",
          color: "error"
        });
      } else {
        await this.$http
          .post("reset-pin/" + this.token, { pin: pin })
          .then(() => {
            this.ok = false;
            this.resetDone = true;
          })
          .catch(() => {
            this.$router.push("/not-found");
          });
      }
    }
  }
};
</script>
<style scoped>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.centerImg {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
</style>
